// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "feature-app." + chunkId + "." + {"162":"5d194d1273bd51d2e0f0","636":"d5d6ace43c31df9e95bb"}[chunkId] + ".css";
};